<div class="reject-reason-dialog">
  <div class="rr-header">
    <p class="rr-title">{{ title }}</p>
    <mat-icon class="rr-close" (click)="close()">close</mat-icon>
  </div>

  <div class="rr-description">
    <p>{{ description }}</p>
  </div>

  <form class="rr-body" [formGroup]="form" (ngSubmit)="submit()">
    <label class="rr-label" for="reject-reason">Reason for Rejection</label>
    <div class="rr-textarea-wrap"
         [class.rr-textarea-error]="reasonMissingError">
      <textarea id="reject-reason"
                class="rr-textarea"
                rows="5"
                formControlName="reason"
                placeholder=""></textarea>
    </div>
    <p class="rr-error" *ngIf="reasonMissingError">
      Please enter a reason for rejection.
    </p>

    <div class="rr-footer">
      <button type="button" class="rr-cancel" (click)="close()">Cancel</button>
      <button type="submit" class="rr-submit">Submit</button>
    </div>
  </form>
</div>
